import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  Tabs,
  Tab,
} from "@mui/material";
import api from "../../utils/api";
import BillingSummaryCards from "./BillingSummaryCards";
import BillingSummaryOverview from "./BillingSummaryOverview";
import BillingSummaryExport from "./BillingSummaryExport";

const BillingSummarySection = () => {
  const [data, setData] = useState([]);
  const [typeMap, setTypeMap] = useState({});
  const [subtypeMap, setSubtypeMap] = useState({});
  const [loading, setLoading] = useState(true);
  const [tabIndex, setTabIndex] = useState(0);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    fetchBillingData();
    fetchWorkOrderTypes();
    fetchWorkOrderSubtypes();
  }, []);

  const fetchBillingData = async () => {
    try {
      const response = await api.get("/jonas-export-reports");
      setData(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error("Error fetching report data:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchWorkOrderTypes = async () => {
    try {
      const response = await api.get("/workorder-types");
      const map = {};
      response.data.forEach((item) => {
        map[item.id] = item.type;
      });
      setTypeMap(map);
    } catch (error) {
      console.error("Error fetching work order types:", error);
    }
  };

  const fetchWorkOrderSubtypes = async () => {
    try {
      const response = await api.get("/workorder-subtypes");
      const map = {};
      response.data.forEach((item) => {
        map[item.id] = item.subtype_name; // ✅ FIXED field name
      });
      setSubtypeMap(map);
    } catch (error) {
      console.error("Error fetching work order subtypes:", error);
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <>
      <Typography variant="h5" sx={{ mt: 5, mb: 2, fontWeight: "bold" }}>
        💰 Billed Work Orders Summary
      </Typography>

      {!loading && (
        <Box sx={{ mb: 3 }}>
          <BillingSummaryCards data={data} />
        </Box>
      )}

      <Box sx={{ mt: 4, mb: 3 }}>
        <Tabs value={tabIndex} onChange={handleTabChange}>
          <Tab label="Overview" />
          <Tab label="Export" />
        </Tabs>
      </Box>

      {tabIndex === 0 && (
        <BillingSummaryOverview
          data={data}
          loading={loading}
          typeMap={typeMap}
          subtypeMap={subtypeMap}
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
        />
      )}

      {tabIndex === 1 && (
        <BillingSummaryExport
          data={data}
          loading={loading}
        />
      )}
    </>
  );
};

export default BillingSummarySection;
